module.exports = __webpack_public_path__ + "static/media/image9.6f3146e7.png";